import { useEffect, useRef } from 'react';

export default function useCursor() {
  const dot  = useRef(null);
  const ring = useRef(null);
  const rx = useRef(0), ry = useRef(0);
  const mx = useRef(0), my = useRef(0);

  useEffect(() => {
    const onMove = e => {
      mx.current = e.clientX;
      my.current = e.clientY;
      if (dot.current) {
        dot.current.style.left = e.clientX + 'px';
        dot.current.style.top  = e.clientY + 'px';
      }
    };
    window.addEventListener('mousemove', onMove);

    let raf;
    const tick = () => {
      rx.current += (mx.current - rx.current) * 0.1;
      ry.current += (my.current - ry.current) * 0.1;
      if (ring.current) {
        ring.current.style.left = rx.current + 'px';
        ring.current.style.top  = ry.current + 'px';
      }
      raf = requestAnimationFrame(tick);
    };
    tick();

    const addHover = () => {
      document.querySelectorAll('a,button,[data-hover]').forEach(el => {
        el.addEventListener('mouseenter', () => {
          dot.current?.classList.add('hover');
          ring.current?.classList.add('hover');
        });
        el.addEventListener('mouseleave', () => {
          dot.current?.classList.remove('hover');
          ring.current?.classList.remove('hover');
        });
      });
    };
    addHover();
    const obs = new MutationObserver(addHover);
    obs.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf);
      obs.disconnect();
    };
  }, []);

  return { dot, ring };
}
